import { useState, useEffect } from 'react';
import logoi from '@/assets/logoi.png';
import logot from '@/assets/logot.png';

const navLinks = [
  { label: 'こだわり', href: '#concept' },
  { label: 'メニュー', href: '#menu' },
  { label: '店舗情報', href: '#info' },
  { label: 'お問い合わせ', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCall = () => {
    window.location.href = 'tel:07077860873';
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled
          ? 'bg-background-white backdrop-blur-md shadow-sm'
          : 'bg-transparent'
        }`}
    >
      <div className="max-w-6xl mx-auto ">
        <div className="flex items-center justify-between h-16 md:h-20 px-5">
          {/* Logo */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="flex items-center cursor-pointer"
            aria-label="湯の華"
          >
            <img
              src={logoi}
              alt=""
              className="h-8 md:h-16 w-auto object-contain"
            />
            <img
              src={logot}
              alt="湯の華"
              className="h-6 md:h-10 w-auto object-contain"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className={`font-sans text-xs tracking-widest transition-colors duration-300 cursor-pointer ${scrolled
                    ? 'text-foreground-800 hover:text-primary-500'
                    : 'text-foreground-800 hover:text-primary-500'
                  }`}
              >
                {link.label}
              </a>
            ))}

          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-300 cursor-pointer ${scrolled
                ? 'text-foreground-700 hover:bg-background-300'
                : 'text-background-50 hover:bg-white/10'
              }`}
            aria-label="メニューを開く"
          >
            <i className={`text-lg ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-400 overflow-hidden ${menuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
          }`}
      >
        <div className="bg-background-200/98 backdrop-blur-md border-t border-background-300/50">
          <div className="px-6 py-5 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="font-sans text-sm text-foreground-700 hover:text-primary-500 tracking-wider transition-colors duration-300 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={() => {
                setMenuOpen(false);
                handleCall();
              }}
              className="whitespace-nowrap cursor-pointer w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-sans text-sm tracking-wider transition-all duration-300"
            >
              <i className="ri-phone-line mr-1.5"></i>
              電話で予約
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}